/* assets/pdpc-compare.js
   PDP "Compare with similar [category]" controller — MULTI-CATEGORY.
   Category, noun, profile and finder come from the block's data attributes
   (set by snippets/pdpc-cat.liquid). Core spec groups + similarity are driven
   by PROFILES; the "Full specifications" list is generic (every custom spec
   metafield). One asset serves treadmills, bikes, cross trainers, rowers, etc.
   v3.0 | 2026-06-28
*/
(function(){
  if (window.__cmpxInit) return; window.__cmpxInit = true;

  function dl(o){ try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(o); if(typeof window.gtag==='function' && o && o.event){ var p={}; for(var k in o){ if(k!=='event') p[k]=o[k]; } window.gtag('event', o.event, p); } }catch(e){} }
  function money(n){ if(n==null||isNaN(n)) return '—'; return '$'+Number(n).toLocaleString('en-AU',{minimumFractionDigits:(n%1?2:0),maximumFractionDigits:2}); }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function num(s){ var m=String(s==null?'':s).match(/-?\d+(?:\.\d+)?/); return m?parseFloat(m[0]):null; }
  function isEmpty(v){ return v==null||v===''||v==='—'; }
  function priceCell(p){ var h=money(p.price); if(p.compare_at&&p.compare_at>p.price) h+='<span class="was">'+money(p.compare_at)+'</span>'; return h; }
  function normDiff(v){ return String(v==null?'':v).replace(/\s+/g,' ').trim().toLowerCase(); }
  function gv(p,keys){ var s=p.specs||{}; for(var i=0;i<keys.length;i++){ var v=s[keys[i]]; if(v!=null&&String(v).trim()!=='') return String(v); } return ''; }
  function modelKey(p){
    var s=String(p.title||'').toLowerCase();
    s=s.replace(String(p.vendor||'').toLowerCase(),' ');
    s=s.replace(/\b(treadmill|folding|auto|automatic|with|w\/|massager|sit[- ]?up|bar|tablet|holder|black|white|grey|gray|pink|blue|smart|walking|pad|running|machine|incline|electric|compact|home|gym|double|fold|the|and|series|spin|bike|upright|recumbent|air|exercise|cross|trainer|elliptical|rowing|rower|magnetic|commercial)\b/g,' ');
    s=s.replace(/[^a-z0-9]+/g,' ').trim();
    var m=s.match(/[a-z]*\d+[a-z0-9]*/);
    return m?m[0]:((s.split(' ')[0])||s);
  }

  var LS_PREFIX='cmpx:v1:';
  function lsGet(cat){ try{ var a=JSON.parse(localStorage.getItem(LS_PREFIX+cat)||'[]'); return Array.isArray(a)?a:[]; }catch(e){ return []; } }
  function lsSet(cat,arr){ try{ localStorage.setItem(LS_PREFIX+cat, JSON.stringify(arr.slice(0,12))); }catch(e){} }
  function lsHas(cat,h){ return lsGet(cat).indexOf(h)>-1; }
  function lsToggle(cat,h){ var a=lsGet(cat); var i=a.indexOf(h); if(i>-1) a.splice(i,1); else a.unshift(h); lsSet(cat,a); return a.indexOf(h)>-1; }
  var SPEC_LABELS={motor_size:'Motor Size',max_speed:'Max Speed',warranty:'Warranty',warranty_detail:'Warranty Detail',app_compatible:'Fitness Apps',running_surface:'Belt Size',weight_capacity:'Weight Capacity',console:'Screen Type',bike_console_type:'Console',incline_decline:'Incline/Decline',foldable:'Foldable',connectivity:'Connectivity',belt_width1:'Belt Width',belt_length1:'Belt Length',drive_system:'Drive System',frame_material:'Frame Material',phone_or_tablet_holder:'Device Holder',watts_power:'Watts/Power',self_powered:'Self-Powered',number_of_programs:'Programs',device_charging:'Device Charging',entertainment_apps:'Entertainment Apps',stride_length:'Stride Length',length:'Length',height:'Height',footprint:'Footprint',incline_positions:'Incline Positions',resistance_levels:'Resistance Levels',resistance_type:'Resistance Type',unit_weight:'Unit Weight',machine_net_weight:'Net Weight',max_user_weight_kg:'Max User Weight',screen_size_inches:'Screen Size (in)',flywheel:'Flywheel',pulse_sensors:'Pulse Sensors',handlebar_type:'Handlebar Type',seat_type:'Seat Type',seat_height:'Seat Height',pedal_type:'Pedal Type',water_bottle_holder:'Water Bottle Holder',rail_length:'Rail Length',step_height:'Step Height',step_rate:'Step Rate',number_of_levels:'Levels'};
  function label(k){ if(SPEC_LABELS[k]) return SPEC_LABELS[k]; var s=k.replace(/_/g,' ').trim(); return s.charAt(0).toUpperCase()+s.slice(1); }

  var PROFILES = {
    treadmill: {
      extra:['belt_length1','belt_width1'],
      groups:[
        {name:'Price & ownership', rows:[ {k:'Price',price:true}, {k:'Warranty',keys:['warranty']}, {k:'Folding',keys:['foldable'],dflt:'Non-folding'} ]},
        {name:'Performance', rows:[ {k:'Motor',keys:['motor_size']}, {k:'Top speed',keys:['max_speed']}, {k:'Incline',keys:['incline_decline'],dflt:'None'} ]},
        {name:'Running surface & build', rows:[ {k:'Belt size',keys:['running_surface']}, {k:'Max user weight',keys:['weight_capacity']} ]}
      ],
      sim:function(a,c){
        var s=0;
        var pa=/walking\s*pad/i.test(a.tags||'')?'wp':'tm', pc=/walking\s*pad/i.test(c.tags||'')?'wp':'tm';
        if(pa!==pc) s+=100000;
        var fa=/folding|folds?\s/i.test((a.tags||'')+' '+gv(a,['foldable'])), fc=/folding|folds?\s/i.test((c.tags||'')+' '+gv(c,['foldable']));
        if(fa!==fc) s+=4000;
        var as=num(gv(a,['max_speed'])), cs=num(gv(c,['max_speed']));
        if(as!=null&&cs!=null) s+=Math.abs(cs-as)*40;
        return s;
      }
    },
    bike: {
      groups:[
        {name:'Price & ownership', rows:[ {k:'Price',price:true}, {k:'Warranty',keys:['warranty']}, {k:'Max user weight',keys:['weight_capacity','max_user_weight_kg','bike_max_user_kg']} ]},
        {name:'Resistance & drive', rows:[ {k:'Resistance',keys:['resistance_type','bike_resistance_kind']}, {k:'Resistance levels',keys:['resistance_levels','bike_resistance_levels']}, {k:'Flywheel',keys:['flywheel','bike_flywheel_kg']}, {k:'Drive system',keys:['drive_system','bike_drive_type']} ]},
        {name:'Console & comfort', rows:[ {k:'Display',keys:['bike_console_type','console','bike_display_type']}, {k:'Programs',keys:['number_of_programs']}, {k:'Seat',keys:['seat_type']} ]}
      ],
      sim:function(a,c){ var s=0; if(normDiff(gv(a,['resistance_type','bike_resistance_kind']))!==normDiff(gv(c,['resistance_type','bike_resistance_kind']))) s+=600; return s; }
    },
    elliptical: {
      groups:[
        {name:'Price & ownership', rows:[ {k:'Price',price:true}, {k:'Warranty',keys:['warranty']}, {k:'Max user weight',keys:['weight_capacity']} ]},
        {name:'Stride & resistance', rows:[ {k:'Stride length',keys:['stride_length']}, {k:'Resistance',keys:['resistance_type']}, {k:'Resistance levels',keys:['resistance_levels']}, {k:'Flywheel',keys:['flywheel']}, {k:'Incline',keys:['incline_decline'],dflt:'None'} ]},
        {name:'Console & build', rows:[ {k:'Display',keys:['console','bike_console_type']}, {k:'Programs',keys:['number_of_programs']} ]}
      ],
      sim:function(a,c){ var s=0; var as=num(gv(a,['stride_length'])), cs=num(gv(c,['stride_length'])); if(as!=null&&cs!=null) s+=Math.abs(cs-as)*30; if(normDiff(gv(a,['resistance_type']))!==normDiff(gv(c,['resistance_type']))) s+=400; return s; }
    },
    rower: {
      groups:[
        {name:'Price & ownership', rows:[ {k:'Price',price:true}, {k:'Warranty',keys:['warranty']}, {k:'Max user weight',keys:['weight_capacity']}, {k:'Folding',keys:['foldable'],dflt:'Non-folding'} ]},
        {name:'Resistance & rail', rows:[ {k:'Resistance',keys:['resistance_type']}, {k:'Resistance levels',keys:['resistance_levels']}, {k:'Flywheel',keys:['flywheel']}, {k:'Rail length',keys:['rail_length']} ]}
      ],
      sim:function(a,c){ var s=0; if(normDiff(gv(a,['resistance_type']))!==normDiff(gv(c,['resistance_type']))) s+=500; return s; }
    }
  };
  function rowDisp(p,row){ if(row.price) return priceCell(p); var v=gv(p,row.keys); return v?esc(v):(row.dflt||'—'); }
  function rowKeyVal(p,row){ if(row.price) return p.price; return normDiff(gv(p,row.keys)); }

  function makeController(root){
    var anchorNode = root.querySelector('[data-cmpx-anchor]');
    if(!anchorNode) return null;
    var ANCHOR; try { ANCHOR = JSON.parse(anchorNode.textContent); } catch(e){ return null; }
    var NOUN = root.getAttribute('data-cmpx-noun') || 'model';
    var NOUN_PL = NOUN + 's';
    var FINDER = root.getAttribute('data-cmpx-finder') || '';
    var CATEGORY = root.getAttribute('data-cmpx-category') || 'all';
    var prof = PROFILES[root.getAttribute('data-cmpx-profile')] || PROFILES.treadmill;
    var qs = new URLSearchParams(location.search);
    var pv = qs.get('preview_theme_id');
    var baseUrl = root.getAttribute('data-cmpx-url') || ANCHOR.url || '';
    var DATA_URL = baseUrl + '?section_id=pdp-compare-data' + (pv ? '&preview_theme_id='+pv : '');

    var CORE_KEYS={};
    prof.groups.forEach(function(g){ g.rows.forEach(function(r){ if(r.keys) r.keys.forEach(function(k){ CORE_KEYS[k]=1; }); }); });
    (prof.extra||[]).forEach(function(k){ CORE_KEYS[k]=1; });

    var catalogue=null, slots=[null,null,null], onlyDiff=false, showMore=false, modal=null, lastFocus=null, loaded=false, viewFired=false;

    function simScore(c){
      var s=Math.abs((c.price||0)-(ANCHOR.price||0));
      if(c.band&&ANCHOR.band&&c.band!==ANCHOR.band) s+=1200;
      if(prof.sim) s+=prof.sim(ANCHOR,c);
      return s;
    }
    function ranked(excl){
      var ex={}; (excl||[]).forEach(function(h){ex[h]=1;});
      return catalogue.filter(function(c){return c.handle!==ANCHOR.handle&&!ex[c.handle];})
        .map(function(c){return {p:c,s:simScore(c)};}).sort(function(a,b){return a.s-b.s;})
        .map(function(x){return x.p;});
    }
    function suggest(ex){
      var aKey=modelKey(ANCHOR);
      var cand=ranked(ex).filter(function(c){return modelKey(c)!==aKey;});
      var seen={},uniq=[]; cand.forEach(function(c){var k=modelKey(c); if(!seen[k]){seen[k]=1;uniq.push(c);}});
      if(uniq.length<2){ uniq=ranked(ex); }
      var ap=ANCHOR.price||0;
      var cheaper=uniq.filter(function(c){return (c.price||0)<=ap;}).sort(function(a,b){return Math.abs((a.price||0)-ap)-Math.abs((b.price||0)-ap);});
      var pricier=uniq.filter(function(c){return (c.price||0)>ap;}).sort(function(a,b){return Math.abs((a.price||0)-ap)-Math.abs((b.price||0)-ap);});
      var out=[cheaper[0]||pricier[1]||uniq[0]||null, pricier[0]||cheaper[1]||uniq[1]||null];
      return out.filter(function(x,i,arr){ return x && arr.indexOf(x)===i; });
    }
    function buildDefaults(){
      var saved=lsGet(CATEGORY).filter(function(h){return h!==ANCHOR.handle;});
      var picks=saved.map(function(h){ for(var i=0;i<catalogue.length;i++){ if(catalogue[i].handle===h) return catalogue[i]; } return null; }).filter(Boolean).slice(0,2);
      slots[1]=picks[0]||null; slots[2]=picks[1]||null;
      if(!slots[1]||!slots[2]){
        var ex=[ANCHOR.handle]; if(slots[1])ex.push(slots[1].handle); if(slots[2])ex.push(slots[2].handle);
        var sug=suggest(ex);
        if(!slots[1]) slots[1]=sug.shift()||null;
        if(!slots[2]) slots[2]=sug.shift()||null;
      }
    }
    function cols(){ return [ANCHOR, slots[1], slots[2]].filter(Boolean); }

    function moreGroup(cs){
      var keys={};
      cs.forEach(function(p){ var s=p.specs||{}; for(var k in s){ if(s.hasOwnProperty(k)&&!CORE_KEYS[k]&&!/^bike_|^ct_/.test(k)&&String(s[k]).trim()!=='') keys[k]=1; } });
      var list=Object.keys(keys).sort(function(a,b){ return label(a).localeCompare(label(b)); });
      return { name:'Full specifications', more:true, rows: list.map(function(k){ return { k:label(k), keys:[k] }; }) };
    }

    function header(p,i){
      var anchor=i===0;
      var swap=anchor?'':'<button type="button" class="cmpx-swap" data-swap="'+i+'"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 3l4 4-4 4"/><path d="M20 7H8"/><path d="M8 21l-4-4 4-4"/><path d="M4 17h12"/></svg>Swap</button>';
      var stock=p.available===false?'<span class="cmpx-stock out">Out of stock</span>':'<span class="cmpx-stock in">In stock</span>';
      return '<th scope="col" class="cmpx-prod'+(anchor?' anchor':'')+'">'+
        '<span class="cmpx-tophdr">'+(anchor?'<span class="cmpx-atag">You’re viewing</span>':swap)+'</span>'+
        '<span class="cmpx-img">'+(p.image?'<img src="'+esc(p.image)+'" alt="'+esc(p.title)+'" loading="lazy">':'')+'</span>'+
        '<span class="cmpx-pv">'+esc(p.vendor)+'</span>'+
        '<span class="cmpx-pt">'+esc(p.title)+'</span>'+
        stock+
        '<a class="cmpx-viewlink" href="'+esc(p.url)+'" data-view="'+esc(p.handle)+'" data-pos="'+i+'">View product →</a></th>';
    }

    function render(){
      var cs=cols();
      var allGroups=prof.groups.concat([moreGroup(cs)]);
      var h='<table class="cmpx-t"><caption style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Specification comparison</caption>';
      h+='<colgroup><col class="cmpx-lcol">'+cs.map(function(){return '<col>';}).join('')+'</colgroup>';
      h+='<thead><tr><th scope="row" aria-hidden="true"></th>'+cs.map(header).join('')+'</tr></thead><tbody>';
      allGroups.forEach(function(g){
        var rowsHtml='';
        g.rows.forEach(function(r){
          var disp=cs.map(function(p){return rowDisp(p,r);});
          if(disp.every(isEmpty)) return;
          var keys=cs.map(function(p){return rowKeyVal(p,r);});
          var allSame=keys.every(function(v){return v===keys[0];});
          if(onlyDiff && allSame && cs.length>1) return;
          rowsHtml+='<tr'+(!allSame?' class="cmpx-isdiff"':'')+'><th scope="row">'+r.k+'</th>'+
            cs.map(function(p,idx){ return '<td'+((onlyDiff && !allSame)?' class="cmpx-diffhi"':'')+'>'+disp[idx]+'</td>'; }).join('')+'</tr>';
        });
        if(rowsHtml){ h+='<tr class="cmpx-grouprow'+(g.more?' cmpx-more-start':'')+'"><th scope="colgroup" colspan="'+(cs.length+1)+'">'+g.name+'</th></tr>'+rowsHtml; }
      });
      h+='</tbody></table>';
      modal.querySelector('[data-cmpx-stage]').innerHTML='<div class="cmpx-specs" data-cmpx-specs>'+h+'</div>';
      var hasMore = moreGroup(cs).rows.length>0;
      var ml=modal.querySelector('[data-cmpx-more]');
      if(ml){ ml.hidden=!hasMore; ml.setAttribute('aria-expanded',showMore?'true':'false'); var lab=ml.querySelector('.cmpx-morelabel'); if(lab) lab.textContent=showMore?'Show fewer specs':'Show more specs'; ml.classList.toggle('cmpx-up',showMore); }
      applyCollapse(false);
      if(!viewFired){ viewFired=true; dl({event:'compare_view',surface:'pdp',category:NOUN,anchor_handle:ANCHOR.handle,suggested:[slots[1]&&slots[1].handle,slots[2]&&slots[2].handle]}); }
    }
    function applyCollapse(animate){
      var wrap=modal.querySelector('[data-cmpx-specs]');
      if(!wrap) return;
      var startRow=wrap.querySelector('.cmpx-more-start');
      if(!startRow){ wrap.classList.remove('cmpx-collapsed'); wrap.style.maxHeight=''; return; }
      var collapsedH=Math.round(startRow.getBoundingClientRect().top - wrap.getBoundingClientRect().top - 2);
      if(showMore){
        wrap.classList.remove('cmpx-collapsed');
        if(animate){ wrap.style.maxHeight=wrap.scrollHeight+'px'; setTimeout(function(){ if(showMore) wrap.style.maxHeight='none'; },360); }
        else { wrap.style.maxHeight='none'; }
      } else {
        wrap.classList.add('cmpx-collapsed');
        if(animate){ wrap.style.maxHeight=wrap.scrollHeight+'px'; requestAnimationFrame(function(){ wrap.style.maxHeight=collapsedH+'px'; }); }
        else { wrap.style.maxHeight=collapsedH+'px'; }
      }
    }
    function buildModal(){
      modal=document.createElement('div');
      modal.className='cmpx cmpx-back';
      var findLink = FINDER ? ' <a href="'+esc(FINDER)+'">Find your match →</a>' : '';
      modal.innerHTML=
        '<div class="cmpx-modal" role="dialog" aria-modal="true" aria-label="Compare '+esc(NOUN_PL)+'">'+
          '<div class="cmpx-mhead"><div><h2>How it stacks up against similar '+esc(NOUN_PL)+'</h2><p>Swap in any model you like. Specs pulled live.</p></div>'+
            '<button type="button" class="cmpx-close" data-cmpx-close aria-label="Close comparison"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'+
          '<div class="cmpx-tools"><label class="cmpx-toggle"><input type="checkbox" data-cmpx-diff> Show only differences</label></div>'+
          '<div class="cmpx-scroll" data-cmpx-stage><div class="cmpx-skel"></div></div>'+
          '<div class="cmpx-foot"><a class="cmpx-morelink" data-cmpx-more href="#" hidden><span class="cmpx-morelabel">Show more specs</span><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></a><div class="cmpx-foot-row"><span class="note">Not sure which is right? Chat to our team'+(FINDER?' or <a href="'+esc(FINDER)+'">Find your match →</a>':'.')+'</span>'+
            '<a class="cmpx-expert" href="tel:0370479313"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>Talk to an expert</a></div>'+
          '</div>'+
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener('click',function(e){
        if(e.target===modal){ close(); return; }
        if(e.target.closest('[data-cmpx-close]')){ close(); return; }
        var mb=e.target.closest('[data-cmpx-more]');
        if(mb){ e.preventDefault(); showMore=!showMore; mb.setAttribute('aria-expanded',showMore?'true':'false'); mb.classList.toggle('cmpx-up',showMore); var lb=mb.querySelector('.cmpx-morelabel'); if(lb) lb.textContent=showMore?'Show fewer specs':'Show more specs'; applyCollapse(true); return; }
        var sw=e.target.closest('[data-swap]'); if(sw){ openPicker(parseInt(sw.getAttribute('data-swap'),10)); return; }
        var v=e.target.closest('[data-view]'); if(v){ dl({event:'compare_product_click',surface:'pdp',category:NOUN,handle:v.getAttribute('data-view'),position:parseInt(v.getAttribute('data-pos'),10)}); }
      });
      modal.querySelector('[data-cmpx-diff]').addEventListener('change',function(e){ onlyDiff=e.target.checked; if(catalogue) render(); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&modal&&modal.classList.contains('on')) close(); });
    }
    function open(){
      lastFocus=document.activeElement;
      if(!modal) buildModal();
      modal.classList.add('on'); document.body.style.overflow='hidden';
      var cl=modal.querySelector('[data-cmpx-close]'); if(cl) cl.focus();
      dl({event:'compare_open',surface:'pdp',category:NOUN,anchor_handle:ANCHOR.handle});
      if(!loaded) loadData();
    }
    function close(){ modal.classList.remove('on'); document.body.style.overflow=''; if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
    function loadData(){
      loaded=true;
      fetch(DATA_URL,{headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); })
        .then(function(txt){
          var node=new DOMParser().parseFromString(txt,'text/html').querySelector('[data-cmp-data]');
          catalogue=JSON.parse((node?node.textContent:txt).trim());
          if(!catalogue.some(function(c){return c.handle===ANCHOR.handle;})) catalogue.push(ANCHOR);
          buildDefaults();
          render();
        })
        .catch(function(){
          loaded=false;
          modal.querySelector('[data-cmpx-stage]').innerHTML='<div class="cmpx-err">We couldn’t load the comparison right now. Please close and try again.</div>';
        });
    }
    function openPicker(slotIdx){
      var other=slots[slotIdx===1?2:1];
      var list=ranked([ANCHOR.handle, other&&other.handle]);
      var back=document.createElement('div'); back.className='cmpx cmpx-pickback';
      back.innerHTML='<div class="cmpx-pick" role="dialog" aria-modal="true" aria-label="Choose a '+esc(NOUN)+'"><h3>Swap in a '+esc(NOUN)+'</h3><input type="search" class="cmpx-search" placeholder="Search by name or brand…" autocomplete="off"><div class="cmpx-plist"></div><button type="button" class="cmpx-pclose">Cancel</button></div>';
      modal.appendChild(back);
      var listEl=back.querySelector('.cmpx-plist'), search=back.querySelector('.cmpx-search');
      function paint(arr){
        listEl.innerHTML=arr.slice(0,40).map(function(p,i){
          var sim=(i<3&&!search.value)?'<span class="sim">Similar</span>':'';
          return '<button type="button" class="cmpx-pi" data-h="'+esc(p.handle)+'">'+(p.image?'<img src="'+esc(p.image)+'" alt="" loading="lazy">':'<span style="width:40px"></span>')+'<span><span class="pt">'+esc(p.title)+'</span><span class="pm">'+esc(p.vendor)+' · '+money(p.price)+'</span></span>'+sim+'</button>';
        }).join('')||'<div style="padding:18px;text-align:center;color:#888;font-size:13px">No matches</div>';
      }
      paint(list); requestAnimationFrame(function(){ back.classList.add('on'); });
      function pclose(){ back.classList.remove('on'); setTimeout(function(){back.remove();},200); }
      back.addEventListener('click',function(e){ if(e.target===back||e.target.closest('.cmpx-pclose')) pclose(); });
      search.addEventListener('input',function(){ var q=search.value.toLowerCase().trim(); paint(q?list.filter(function(p){return (p.title+' '+p.vendor).toLowerCase().indexOf(q)>-1;}):list); });
      listEl.addEventListener('click',function(e){
        var b=e.target.closest('[data-h]'); if(!b) return;
        var pick=catalogue.filter(function(c){return c.handle===b.getAttribute('data-h');})[0];
        if(pick){ var from=slots[slotIdx]; dl({event:'compare_swap',surface:'pdp',category:NOUN,slot:slotIdx,from_handle:from&&from.handle,to_handle:pick.handle}); slots[slotIdx]=pick; render(); }
        pclose();
      });
    }
    return { open: open };
  }

  function updateBar(root){
    var cat=root.getAttribute('data-cmpx-category'); if(!cat) return;
    var an=root.querySelector('[data-cmpx-anchor]'); var h; try{ h=JSON.parse(an.textContent).handle; }catch(e){ return; }
    var added=lsHas(cat,h);
    var add=root.querySelector('[data-cmpx-add]');
    if(add){ add.classList.toggle('is-added',added); add.setAttribute('aria-pressed',added?'true':'false'); var t=add.querySelector('[data-cmpx-addlabel]'); if(t) t.textContent=added?'In your compare list':'Add to compare'; }
    var cnt=root.querySelector('[data-cmpx-count]'); if(cnt){ var n=lsGet(cat).length; cnt.textContent=n>0?(' ('+n+')'):''; }
  }
  function updateAllBars(){ var rs=document.querySelectorAll('.cmpx[data-cmpx-category]'); for(var i=0;i<rs.length;i++) updateBar(rs[i]); }
  var controllers = new WeakMap();
  document.addEventListener('click', function(e){
    var addBtn=e.target.closest('[data-cmpx-add]');
    if(addBtn){ e.preventDefault(); var ar=addBtn.closest('.cmpx'); if(!ar) return; var acat=ar.getAttribute('data-cmpx-category'); var ah; try{ ah=JSON.parse(ar.querySelector('[data-cmpx-anchor]').textContent).handle; }catch(_){ return; } var nowAdded=lsToggle(acat,ah); dl({event:'compare_add',surface:'pdp',category:acat,handle:ah,added:nowAdded}); updateAllBars(); return; }
    var btn = e.target.closest('[data-cmpx-open]');
    if(!btn) return;
    var root = btn.closest('.cmpx');
    if(!root) return;
    e.preventDefault();
    var ctrl = controllers.get(root);
    if(!ctrl){ ctrl = makeController(root); if(ctrl) controllers.set(root, ctrl); }
    if(ctrl) ctrl.open();
  });
  function cmpxBoot(){ updateAllBars(); try{ if(new URLSearchParams(location.search).get('cmpx')==='open'){ var r=document.querySelector('.cmpx[data-cmpx-category]'); if(r){ var c=controllers.get(r); if(!c){ c=makeController(r); if(c) controllers.set(r,c); } if(c) c.open(); } } }catch(e){} }
  if(document.readyState!=='loading'){ cmpxBoot(); } else { document.addEventListener('DOMContentLoaded', cmpxBoot); }
})();
